module.exports = __webpack_public_path__ + "img/account_pc_04.ba7c7cbd.webp";